import { c as _c } from "react/compiler-runtime";
import { COURSE_BUNDLES_API } from 'modules/courses/bundles/api/course-bundles-api';
import { CourseBundleInterface } from 'modules/courses/bundles/course-bundle/types/course-bundle-interface';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { coursesDependencies } from '../../../constants/courses-dependencies';
export function useCourseBundle(id) {
  const $ = _c(6);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== id) {
    t1 = () => [`${COURSE_BUNDLES_API}/${id}`, RequestModuleEnum.CourseBundle, ...coursesDependencies];
    $[1] = id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: courseBundleData,
    mutate
  } = useControlledSwr(t1, fetcher, undefined, !!user);
  let t2;
  if ($[3] !== courseBundleData || $[4] !== mutate) {
    t2 = {
      courseBundleData,
      mutate
    };
    $[3] = courseBundleData;
    $[4] = mutate;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}